import { getEnvironmentVariable } from "./environmentVariables";

const getIsFeatureFlagEnabled = (featureFlagName: string) =>
  getEnvironmentVariable(featureFlagName) === "ENABLED";
export const getIsPasskeyFlagEnabled = () => getIsFeatureFlagEnabled("PASSKEY");
export const getPasskeyApiUrl = () => getEnvironmentVariable("PASSKEY_API_URL") ?? "";
